// SplitText, CustomEase, ScrollToPlugin, ScrollSmoother are available free
// as of late 2024 — they ship inside the main gsap package at v3.12+.

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { CustomEase } from 'gsap/CustomEase'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { Flip } from 'gsap/Flip'
import { Draggable } from 'gsap/Draggable'
import { InertiaPlugin } from 'gsap/InertiaPlugin'
import { useGSAP } from '@gsap/react'

let initialized = false

export function gsapSetup() {
  if (initialized) return
  initialized = true

  gsap.registerPlugin(
    ScrollTrigger, SplitText, CustomEase, ScrollToPlugin,
    Flip, Draggable, InertiaPlugin, useGSAP,
  )

  // BioSoil signature easing — cubic-bezier(.77,0,.175,1)
  CustomEase.create('biosoil', 'M0,0 C0.77,0 0.175,1 1,1')
}
